(() => {
  if (window.scaNewsletterSite) return;
  window.scaNewsletterSite = true;
  const storageKey = 'sca-newsletter-return-v1';
  const wrapperSelector = 'sca-newsletter, .scah-newsletter, .scapd-newsletter, [data-newsletter-section]';
  const isNewsletter = (form) => {
    if (!(form instanceof HTMLFormElement)) return false;
    if (form.querySelector('[name="form_type"]')?.value !== 'customer') return false;
    const tags = form.querySelector('[name="contact[tags]"]')?.value || '';
    return tags.split(',').some((tag) => tag.trim().toLowerCase() === 'newsletter') ||
      !!form.closest(wrapperSelector) || /newsletter/i.test(form.id);
  };
  const targetFor = (form) => form.closest(wrapperSelector) || form;
  const prepare = (form) => {
    if (!isNewsletter(form)) return null;
    if (!form.id) form.id = 'sca-site-newsletter-' + Array.from(document.forms).indexOf(form);
    const target = targetFor(form);
    if (!target.id) target.id = form.id + '-section';
    target.style.scrollMarginTop = '150px';
    const url = new URL(window.location.href);
    url.searchParams.delete('contact_posted');
    url.searchParams.delete('form_type');
    url.searchParams.set('customer_posted', 'true');
    url.hash = target.id;
    let input = form.querySelector('[name="return_to"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'return_to';
      form.appendChild(input);
    }
    input.value = url.pathname + url.search + url.hash;
    return {target: target.id, form: form.id, path: url.pathname, time: Date.now()};
  };
  const setup = () => Array.from(document.forms).forEach(prepare);
  document.addEventListener('submit', (event) => {
    const record = prepare(event.target);
    if (!record) return;
    try { sessionStorage.setItem(storageKey, JSON.stringify(record)); } catch (_) {}
  }, true);
  const restore = () => {
    setup();
    let record;
    try { record = JSON.parse(sessionStorage.getItem(storageKey)); } catch (_) {}
    const url = new URL(window.location.href);
    if (!record || record.path !== url.pathname || Date.now() - record.time > 600000) return;
    const hasResponse = url.searchParams.has('customer_posted') || url.searchParams.get('form_type') === 'customer' ||
      url.hash === '#' + record.target || url.hash === '#' + record.form;
    if (!hasResponse) return;
    const form = document.getElementById(record.form);
    const target = document.getElementById(record.target) || (form && targetFor(form));
    if (!target) return;
    try { sessionStorage.removeItem(storageKey); } catch (_) {}
    const controller = new AbortController();
    let stopped = false;
    const stop = () => { stopped = true; controller.abort(); };
    ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach((name) =>
      window.addEventListener(name, stop, {once:true, passive:true, signal:controller.signal}));
    const reveal = () => {
      if (stopped || !target.isConnected) return;
      target.classList.remove('is-pending');
      const focusTarget = target.querySelector('[role="alert"], .errors, [data-newsletter-result], [role="status"]') || target;
      if (!focusTarget.hasAttribute('tabindex')) focusTarget.setAttribute('tabindex', '-1');
      focusTarget.focus({preventScroll:true});
      target.scrollIntoView({block:'start', behavior:'instant'});
    };
    requestAnimationFrame(reveal);
    window.addEventListener('load', reveal, {once:true, signal:controller.signal});
    window.addEventListener('pageshow', reveal, {once:true, signal:controller.signal});
    setTimeout(reveal, 250);
    setTimeout(() => { reveal(); stop(); }, 1000);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restore, {once:true});
  else restore();
  document.addEventListener('shopify:section:load', setup);
})();
